import React, { useEffect, useState } from 'react';
import S from './BackgroundVideo.styled';
import { IAsset } from '@/src/types';
import { modifyImage } from '@/src/helpers/modifyImage';
import { log } from 'node:console';

type Props = {
  media: IAsset;
  overlay?: boolean;
  vimeoId?: string;
  isProductPage?: boolean;
  fullScreen?: boolean;
  height?: number;
  overlayType?: 'gradient' | 'overlay';
  overlayOpacity: number;
  alignBottom?: boolean;
};

const BackgroundVideo: React.FC<Props> = ({
  media,
  overlay,
  vimeoId,
  isProductPage,
  fullScreen,
  height,
  overlayType = 'overlay',
  overlayOpacity,
  alignBottom = false,
}) => {
  const [thumbnailUrl, setThumbnailUrl] = useState('');

  useEffect(() => {
    if (!vimeoId) return;

    fetch(`https://vimeo.com/api/v2/video/${vimeoId}.json`)
      .then((response) => response.json())
      .then((data) => {
        const thumbnail = data[0].thumbnail_large;
        setThumbnailUrl(thumbnail);
      })
      .catch((error) =>
        console.error('Error fetching Vimeo video thumbnail:', error)
      );
  }, [vimeoId]);

  const modImage = modifyImage(media, '1920x1080');

  return (
    <>
      {vimeoId && media?.filename && (
        <S.PosterImage src={modImage} alt={media.alt} />
      )}
      {!media?.filename && thumbnailUrl && (
        <S.PosterImage src={thumbnailUrl} alt="Vimeo video thumbnail" />
      )}
      {vimeoId && (
        <S.VideoWrapper
          $fullScreen={fullScreen}
          $isProductPage={isProductPage}
          $height={height}
        >
          <S.VimeoWrapper
            $isProductPage={isProductPage}
            $fullScreen={fullScreen}
            $height={height}
          >
            <iframe
              src={`https://player.vimeo.com/video/${vimeoId}?dnt=1&background=1&autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1&autopause=0&controls=0&playsinline=1`}
              allow="autoplay; fullscreen; picture-in-picture"
              title="Vimeo video"
              frameBorder={0}
              tabIndex={-1}
            ></iframe>
          </S.VimeoWrapper>
        </S.VideoWrapper>
      )}
      {!vimeoId && media && media.filename && (
        <S.Video
          autoPlay
          loop
          muted
          playsInline
          $isProductPage={isProductPage}
          $fullScreen={fullScreen}
          $height={height}
        >
          <source src={media.filename} type="video/mp4" />
        </S.Video>
      )}

      {overlay && (
        <S.Overlay
          $opacity={overlayOpacity}
          $overlayType={overlayType}
          $alignBottom={alignBottom}
        />
      )}
    </>
  );
};

export default BackgroundVideo;
